<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type mgr_15">
					<select id="dlActive" v-model="active_yn" @change="search()">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>

				<span class="int_type mgr_10">
					<select v-model="partner_type" @change="search()">
						<option value="A">All</option>
						<option value="C">Customer</option>
						<option value="V">Vendor</option>
						<option value="B">Both</option>
					</select>
				</span>

				<em class="lt_text">Grade</em>
				<span class="int_type_no_border mgr_10"> <CodeSelect :width="60" :showDesc="false" :codes="grades" v-model="grade" /> </span>

				<em class="lt_text">Country</em>
				<span class="int_type_no_border mgr_10">
					<CodeSelect :width="100" :showDesc="false" :codes="countries" v-model="country" @post-loading="postCountryLoading" />
				</span>

				<em class="lt_text">State</em>
				<span class="int_type_no_border mgr_10"> <CodeSelect :width="100" :codeWidth="120" :showDesc="false" :codes="filteredStates" v-model="state" /> </span>

				<span>
					<em class="lt_text">Sales Group</em>
					<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" :showDesc="false" v-model="sales_group_code"/></span>
				</span>

				<span class="int_type">
					<input type="text" v-model="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt mgr_15" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl">
			<thead></thead>
			<tbody></tbody>
		</table>

		<div class="bottom_bt_box"></div>
	</div>
</template>

<script>
import { apiIndex } from '@/api/partner';
import CodeSelect from '@/components/common/CodeSelect';

export default {
	name: 'CustomerStatement',
	data() {
		return {
			active_yn: 'A',
			partner_type: 'A',
			keyword: null,
			grade: '',
			grades: [],
			state: '',
			states: [],
			country: '',
			countries: [],
			salesGroups: [],
			sales_group_code: '',
		};
	},
	methods: {
		async index() {
			const { data } = await apiIndex();

			this.grades = data.gradeList;
			this.states = data.stateList;
			this.countries = data.countryList;
			this.salesGroups = data.salesGroupList;
		},

		postCountryLoading() {
			let session_country = this.$session.get('partner_country');
			if (session_country) {
				if (session_country !== '__blank') this.country = session_country;
			} else {
				this.country = 'US';
			}
		},
		search() {
			this.getParam();
			console.log('search');
		},
		reset() {
			console.log('reset');
		},
		getParam() {
			return {
				active_yn: this.active_yn,
				partner_type: this.partner_type,
				keyword: this.keyword,
				grade: this.grade,
				state: this.state,
				country: this.country,
				sales_group_code: this.sales_group_code,
			};
		},
	},
	mounted() {
		this.index();
	},
	computed: {
		filteredStates() {
			if (!this.country && this.user.company_id == 'newjigu') return this.states;

			const vm = this;
			const fStates = this.states.filter(s => s.country === vm.country);
			if (fStates.length === 0) vm.state = null;
			return fStates;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CodeSelect,
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_customer_statement');
		this.$store.commit('setSubTitle', 'Report -> Customer Statement');
	},
};
</script>

<style scoped></style>
